import React from "react";
import { ClipLoader } from 'react-spinners';
// import { Icon } from 'semantic-ui-react'

import { IChildProp } from "lib/interfaces/IChildProp";
// import { ClipLoader } from "react-spinners";
interface IContentLoaderProps extends IChildProp {
  isLoading: boolean;
}
export const ContentLoader = (props: IContentLoaderProps) => {
  if (!props.isLoading) {
    return props.children;
  }
  return (
    <div
      className="w-100"
      style={{ minHeight: "42vh", width: '100%', justifyContent: 'center', display: 'flex', paddingTop: '200px' }}
    >
      <ClipLoader color={"#000000"} loading={true} size={60} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/loader/ContentLoader.tsx